import { useQuery, UseQueryResult } from 'react-query';
import { APIKeysApi, ApiKey } from 'api/api-keys';
import { fiveMinutes } from './constants';

export const GET_ZAPIER_KEY = 'getZapierKey';
export const GET_WORKATO_KEY = 'getWorkatoKey';
export const GET_RL_KEY = 'getRLApiKey';
export const GET_HUBSPOT_KEY = 'getHubspotKey';

export const useGetZapierKey = (): UseQueryResult<ApiKey, unknown> => {
  return useQuery(GET_ZAPIER_KEY, () => APIKeysApi.getZapierKey(), {
    retry: 1,
    staleTime: fiveMinutes,
  });
};

export const useGetWorkatoKey = (): UseQueryResult<ApiKey, unknown> => {
  return useQuery(GET_WORKATO_KEY, () => APIKeysApi.getWorkatoKey(), {
    retry: 1,
    staleTime: fiveMinutes,
  });
};

export const useGetRLApiKey = (): UseQueryResult<ApiKey[], unknown> => {
  return useQuery(GET_RL_KEY, () => APIKeysApi.getRLApiKey(), {
    retry: 1,
    staleTime: fiveMinutes,
  });
};

export const useGetHubspotKey = (): UseQueryResult<ApiKey, unknown> => {
  return useQuery(GET_HUBSPOT_KEY, () => APIKeysApi.getHubspotKey(), {
    retry: 1,
    staleTime: fiveMinutes,
  });
};
